export const COOKIE_DEVICE_ID = 'x-bt';

// Session info is base64 encoded. Note: if we move this to encryption, we likely need to move
// The encryption private key OUT of common, or it might get packaged and shipped down to the client
export const COOKIE_SESSION_KEY = 'x-s';

// Indicates whether this request comes from react (shef-web) or the app (consumer-app)
export const COOKIE_SOURCE = 'x-source';
